import React from 'react'
import { getStartEndDate } from '../../../../../helpers/getStartEndDate';
import { numberFormat } from '../../../../../helpers/numberFormat';


const FiveRincianPembayaranIndividu = (props) => {
    return (
        <>
            <div className='row' style={{ marginLeft: '5px' }}>
                <h5 style={{ color: '#26D07C', marginBottom: '2%', fontSize: '16px', fontWeight: '700' }}>Rincian Pembayaran</h5>
                <div className='col-lg-12'>
                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr className="text-gray-800 border-bottom border-gray-200">
                                            <th className='text-center'>Nama Program</th>
                                            <th className='text-center'>Jadwal Program</th>
                                            <th className='text-center'>Harga</th>
                                            <th className='text-center'>Jumlah Peserta</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            props.programSelected.map((program, j) =>
                                                <>
                                                    <tr className="fw-bold text-gray-800 border-bottom border-gray-200">
                                                        <td>{program.name}</td>
                                                        <td>{getStartEndDate(props.scheduleSelected, program.id)}</td>
                                                        <td>Rp. {numberFormat(program?.Pricebooks[0].price)}</td>
                                                        <td className='text-center'>1</td>
                                                    </tr>
                                                    <tr className="fw-bold text-gray-800 border-bottom border-gray-200">
                                                    </tr>
                                                </>
                                            )
                                        }

                                        {
                                            props.bpSelected.map((bp, j) =>
                                                <>
                                                    <tr className="fw-bold  text-gray-800 border-bottom border-gray-200">
                                                        <td>{bp.name}</td>
                                                        <td>Bundling</td>
                                                        <td>Rp. {numberFormat(bp.price)}</td>
                                                        <td className='text-center'>1</td>
                                                    </tr>
                                                    <tr className="fw-bold  text-gray-800 border-bottom border-gray-200">
                                                    </tr>
                                                </>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FiveRincianPembayaranIndividu
